import { render, staticRenderFns } from "./TopBarComponent.vue?vue&type=template&id=8c92cba2&"
import script from "./TopBarComponent.vue?vue&type=script&lang=js&"
export * from "./TopBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopBarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports